export default {
  role: null,
}
